import { ScopeMenu } from "@/organisms/ScopeMenu"

import type { ScopeSideNavigationComponent } from ".."

export const ScopeSideNavigation: ScopeSideNavigationComponent = (props) => {
  const { collapsed } = props

  return <ScopeMenu collapsed={collapsed} />
}
